// @ts-strict-ignore
export function parseFilters(query) {
  let filters = {}
  Object.keys(query)
    .filter((key) => !['sort', 'page'].includes(key))
    .forEach((key) => {
      if (!isNaN(parseInt(key, 10))) {
        filters[parseInt(key, 10)] = query[key].split(',').map((i) => parseInt(i, 10))
      }
    })

  return filters
}
